
export const buttons = {
  submit: 'Enviar',
  cancel: 'Cancelar',
  continue: 'Continuar',
  back: 'Voltar',
  next: 'Próximo',
  finish: 'Finalizar',
  save: 'Salvar',
  edit: 'Editar',
  delete: 'Excluir',
  confirm: 'Confirmar',
  close: 'Fechar',
  retry: 'Tentar Novamente',
  loading: 'Carregando...',
  cognitiveAssessment: 'Começar Avaliação Cognitiva',
  behavioralAssessment: 'Começar Avaliação Comportamental',
  downloadPDF: 'Baixar PDF',
  print: 'Imprimir',
  share: 'Compartilhar',
  startAssessment: 'Começar Avaliação',
  completeAssessment: 'Completar Avaliação',
  retakeAssessment: 'Refazer Avaliação',
  viewResults: 'Ver Resultados',
  backToHome: 'Voltar ao Início'
};

export const language = {
  select: 'Selecionar Idioma',
  english: 'Inglês',
  portuguese: 'Português',
  spanish: 'Espanhol'
};

export const userForm = {
  title: 'Completar Seu Perfil',
  subtitle: 'Por favor forneça suas informações para receber seus resultados personalizados',
  fullName: 'Nome Completo',
  fullNamePlaceholder: 'Digite seu nome completo',
  email: 'Endereço de Email',
  emailPlaceholder: 'Digite seu endereço de email',
  language: 'Idioma Preferido',
  continue: 'Continuar para Resultados',
  required: 'Campo obrigatório'
};

export const errors = {
  generic: 'Algo deu errado. Por favor tente novamente.',
  network: 'Erro de conexão. Verifique sua conexão com a internet.',
  validation: 'Por favor verifique sua entrada e tente novamente.',
  unauthorized: 'Você deve estar logado para continuar.',
  notFound: 'Recurso não encontrado.',
  serverError: 'Erro do servidor. Por favor tente mais tarde.',
  loadingFailed: 'Falha ao carregar dados. Por favor tente novamente.',
  saveFailed: 'Falha ao salvar. Por favor tente novamente.',
  deleteFailed: 'Falha ao excluir. Por favor tente novamente.',
  assessmentError: 'Erro de avaliação. Por favor tente novamente.',
  translationMissing: 'Tradução faltando',
  invalidData: 'Dados inválidos fornecidos',
  sessionExpired: 'Sua sessão expirou. Por favor entre novamente.'
};

export const common = {
  loading: 'Carregando...',
  saving: 'Salvando...',
  success: 'Sucesso!',
  error: 'Erro',
  warning: 'Aviso',
  info: 'Informação',
  yes: 'Sim',
  no: 'Não',
  ok: 'OK',
  or: 'ou',
  and: 'e',
  of: 'de',
  to: 'para',
  from: 'de',
  in: 'em',
  at: 'em',
  on: 'em',
  with: 'com',
  without: 'sem',
  page: 'Página',
  total: 'Total',
  count: 'Quantidade',
  date: 'Data',
  time: 'Hora',
  name: 'Nome',
  description: 'Descrição',
  status: 'Status',
  type: 'Tipo',
  category: 'Categoria',
  priority: 'Prioridade',
  search: 'Buscar',
  filter: 'Filtrar',
  sort: 'Ordenar',
  export: 'Exportar',
  import: 'Importar',
  copy: 'Copiar',
  paste: 'Colar',
  cut: 'Cortar',
  undo: 'Desfazer',
  redo: 'Refazer',
  refresh: 'Atualizar',
  reset: 'Redefinir',
  clear: 'Limpar',
  select: 'Selecionar',
  selectAll: 'Selecionar Tudo',
  none: 'Nenhum',
  all: 'Todos',
  more: 'Mais',
  less: 'Menos',
  show: 'Mostrar',
  hide: 'Ocultar',
  expand: 'Expandir',
  collapse: 'Recolher',
  open: 'Abrir',
  close: 'Fechar',
  min: 'Mín',
  max: 'Máx',
  avg: 'Média',
  today: 'Hoje',
  yesterday: 'Ontem',
  tomorrow: 'Amanhã',
  week: 'Semana',
  month: 'Mês',
  year: 'Ano',
  hour: 'Hora',
  minute: 'Minuto',
  second: 'Segundo',
  am: 'AM',
  pm: 'PM',
  learnMore: 'Saiba mais',
  switch: 'Alternar',
  completedOn: 'Concluído em',
  model: 'Modelo'
};
